module.exports = __webpack_public_path__ + "img/DE00386.dd5dd1a0.svg";